import { render, staticRenderFns } from "./myPassWordSet.vue?vue&type=template&id=b1670c4a&scoped=true&"
import script from "./myPassWordSet.vue?vue&type=script&lang=js&"
export * from "./myPassWordSet.vue?vue&type=script&lang=js&"
import style0 from "./myPassWordSet.vue?vue&type=style&index=0&id=b1670c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1670c4a",
  null
  
)

export default component.exports